// extracted by mini-css-extract-plugin
export default {"Company":"Company_Company__Ak+af","Company__logo":"Company_Company__logo__-CWeA","Company__char":"Company_Company__char__gD5W8","Company__name":"Company_Company__name__vGRSc"};